import { errorManager } from "../error-handler";
import { getServiceByProductType } from "../services";
import { ProductType } from "../constants/products";
import appConfig from "@/configs/app-config";

/**
 * Analytics Event Tracker
 * Ürün tipine göre servis seçimi yaparak event'leri track eder
 */
export const track = async (event, data) => {
  try {
    // Data içinden productType'ı al
    const productType = data?.productType;
    if (!productType) {
      console.warn(
        `Analytics: productType bulunamadı. Event: ${event}, Data:`,
        data,
      );
      return;
    }

    // Ürün tipine göre servis seç
    const service = getServiceByProductType(productType);

    if (!service) {
      console.warn(
        `Analytics: ${productType} ürün tipi için servis bulunamadı. Event: ${event}`,
      );
      return;
    }

    // Servis aktifse track et
    if (appConfig.THIRD_PARTY_OPTIONS.GOOGLE.ANALYTICS.ACTIVE) {
      await service.track(event, data);
    }
  } catch (error) {
    errorManager.logError({
      event: event,
      message: error.message,
    });
  }
};
